import { CancelToken } from 'axios';

import resolveV2 from '@/endpoints/resolverV2';
import DataResponse from '@/endpoints/types';

import { ILatestCDLStatsResponse } from '../../../models/cdl';
import { AcresFeature } from '../../../models/features';

interface IData {
  boundary: AcresFeature;
}

export default function getLatestCDLStats(
  data: IData,
  cancelToken?: CancelToken
): Promise<DataResponse<ILatestCDLStatsResponse>> {
  return resolveV2(
    {
      cancelToken,
      data,
      method: 'POST',
      url: '/geoserver/cdl_stats/latest',
    },
    {
      baseUrl: 'geoserver',
    }
  );
}
